import { graphql } from '../../gql';

export const QUERY_TRANSITIONS_V3 = graphql(`
  query QueryTransitionsV3($req: TransitionsV3Req) {
    transitions_v3(req: $req) {
      entities {
        id
        index
        short_name
        long_name
        metrics {
          flows_inflows {
            items {
              id
              short_name
              long_name
              count
              share
            }
          }
          flows_outflows {
            items {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_inflows {
            role {
              id
              short_name
              long_name
              count
              share
            }
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
            gender {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_current {
            gender {
              id
              short_name
              long_name
              count
              share
            }
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            role {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_outflows {
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            role {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
            gender {
              id
              short_name
              long_name
              count
              share
            }
          }
        }
      }
    }
  }
`);
